import { BiDoorOpen, BiVideo } from 'react-icons/bi'

import { Circle, Icon } from '@chakra-ui/react'

import { Alarm } from '@/components/icons'
import { DeviceStatus, DeviceType } from '@/graphql/generated/schemas'
import { getDeviceStatusColor } from '@/utils/devices'

interface DeviceIconPropsIProps {
  status?: DeviceStatus
}

export const getDeviceIcon = (
  type: DeviceType,
  deviceHealth?: DeviceStatus
) => {
  switch (type) {
    case DeviceType.Alarm:
      return <AlarmIcon status={deviceHealth} />
    case DeviceType.Camera:
      return <CameraIcon status={deviceHealth} />
    default:
      return <DoorIcon status={deviceHealth} />
  }
}

export const CameraIcon = ({
  status = DeviceStatus.Healthy,
}: DeviceIconPropsIProps) => (
  <Circle
    bgColor={getDeviceStatusColor(status)}
    borderColor='#fff'
    borderWidth='3px'
    className='handle'
    size='40px'
  >
    <BiVideo color='#fff' />
  </Circle>
)

export const DoorIcon = ({
  status = DeviceStatus.Healthy,
}: DeviceIconPropsIProps) => (
  <Circle
    bgColor={getDeviceStatusColor(status)}
    borderColor='#fff'
    borderWidth='3px'
    className='handle'
    size='40px'
  >
    <BiDoorOpen color='#fff' />
  </Circle>
)

export const AlarmIcon = ({
  status = DeviceStatus.Healthy,
}: DeviceIconPropsIProps) => (
  <Circle
    bgColor={getDeviceStatusColor(status)}
    borderColor='#fff'
    borderWidth='3px'
    className='handle'
    size='40px'
  >
    <Icon as={Alarm} boxSize={5} strokeColor='#fff' />
  </Circle>
)
